import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import LereService from '~/services/LereService';

import { lereDynamicPricingExclusionsQueryKeys } from './lereDynamicPricingExclusionsQueryKeys';

export function useDeleteDynamicPricingExclusion() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (entityId: string) => {
      await LereService.deleteDynamicPricingExclusion(entityId);
    },
    onSuccess: (_data, entityId) => {
      queryClient.invalidateQueries({ queryKey: lereDynamicPricingExclusionsQueryKeys.all });
      enqueueSnackbar(`Removed ${entityId} from exclusion list`, { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to remove exclusion: ${error.message || 'Unknown error'}`, {
        variant: 'error',
      });
    },
  });
}
